"use strict";

// URL L 參數 ↔ sessionStorage.locale（EN / CH）
// 格式：#/photo?L=EN（英文）、#/photo?L=TW 或不帶參數（中文）
// 亦相容舊格式：?L=EN#/photo
export function localeToLangParam(locale) {
    return locale === 'EN' ? 'EN' : 'TW';
}

export function langParamToLocale(langParam) {
    var value = (langParam || '').toUpperCase();
    if (value === 'EN') return 'EN';
    if (value === 'TW' || value === 'CH') return 'CH';
    return null;
}

function getQueryValue(queryString, key) {
    if (!queryString) return null;
    var match = queryString.match(new RegExp('(?:^|&)' + key + '=([^&]*)', 'i'));
    return match ? decodeURIComponent(match[1]) : null;
}

function setQueryValue(queryString, key, value) {
    var pairs = [];
    var found = false;
    if (queryString) {
        queryString.split('&').forEach(function(pair) {
            if (!pair) return;
            var parts = pair.split('=');
            var name = parts[0];
            if (name.toLowerCase() === key.toLowerCase()) {
                if (value != null && value !== '') {
                    pairs.push(key + '=' + encodeURIComponent(value));
                }
                found = true;
                return;
            }
            pairs.push(pair);
        });
    }
    if (!found && value != null && value !== '') {
        pairs.push(key + '=' + encodeURIComponent(value));
    }
    return pairs.join('&');
}

export function getUrlLangParam() {
    // 優先讀 hash query：#/photo?L=EN
    var hash = window.location.hash || '';
    var qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
        var fromHash = getQueryValue(hash.substring(qIndex + 1), 'L');
        if (fromHash) return fromHash;
    }

    // 相容：?L=EN#/...
    try {
        var params = new URLSearchParams(window.location.search);
        var fromSearch = params.get('L');
        if (fromSearch) return fromSearch;
    } catch (error) {
        var match = window.location.search.match(/[?&]L=([^&]*)/i);
        if (match) return decodeURIComponent(match[1]);
    }
    return null;
}

// 進站時依 URL L 寫入語系；有參數以 URL 為準，不帶參數一律中文
export function syncLocaleFromUrl() {
    var localeFromUrl = langParamToLocale(getUrlLangParam());
    var locale = localeFromUrl || 'CH';
    sessionStorage.setItem('locale', locale);
    normalizeLangParamToHash(locale, !!localeFromUrl);
    return locale;
}

// 將 L 統一寫入 hash query，並清掉 search 上的 L
function normalizeLangParamToHash(locale, hasLangInUrl) {
    var hash = window.location.hash || '#/';
    var pathPart = hash;
    var queryPart = '';
    var qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
        pathPart = hash.substring(0, qIndex);
        queryPart = hash.substring(qIndex + 1);
    }
    if (!pathPart || pathPart === '#') pathPart = '#/';

    var nextQuery = queryPart;
    if (hasLangInUrl) {
        nextQuery = setQueryValue(queryPart, 'L', localeToLangParam(locale));
    } else {
        nextQuery = setQueryValue(queryPart, 'L', null);
    }

    var nextHash = nextQuery ? pathPart + '?' + nextQuery : pathPart;

    var search = window.location.search;
    if (/[?&]L=/i.test(search)) {
        search = search
            .replace(/([?&])L=[^&]*/i, '$1')
            .replace(/\?&/, '?')
            .replace(/[?&]$/, '')
            .replace(/\?&/, '?');
        if (search === '?') search = '';
    }

    var next = window.location.pathname + search + nextHash;
    var current = window.location.pathname + window.location.search + window.location.hash;
    if (next !== current) {
        window.history.replaceState(null, '', next);
    }
}

// 語系切換時更新 hash query：英文 ?L=EN、中文移除 L（等同不帶參數）
export function updateUrlLangParam(locale) {
    var hash = window.location.hash || '#/';
    var pathPart = hash;
    var queryPart = '';
    var qIndex = hash.indexOf('?');
    if (qIndex !== -1) {
        pathPart = hash.substring(0, qIndex);
        queryPart = hash.substring(qIndex + 1);
    }
    if (!pathPart || pathPart === '#') pathPart = '#/';

    var nextQuery = locale === 'EN'
        ? setQueryValue(queryPart, 'L', 'EN')
        : setQueryValue(queryPart, 'L', null);

    var nextHash = nextQuery ? pathPart + '?' + nextQuery : pathPart;

    var search = window.location.search;
    if (/[?&]L=/i.test(search)) {
        search = search
            .replace(/([?&])L=[^&]*/i, '$1')
            .replace(/\?&/, '?')
            .replace(/[?&]$/, '')
            .replace(/\?&/, '?');
        if (search === '?') search = '';
    }

    var nextUrl = window.location.pathname + search + nextHash;
    window.history.replaceState(null, '', nextUrl);
    return nextUrl;
}

// 站內 hash 路徑補上目前語系 L（英文必帶 ?L=EN）
export function withLocaleHashPath(path) {
    var raw = path || '';
    if (raw.indexOf('http') === 0) return raw;

    var hashPath = raw.charAt(0) === '#' ? raw : ('#/' + raw.replace(/^\//, ''));
    var locale = sessionStorage.getItem('locale') || 'CH';
    if (locale !== 'EN') {
        // 中文：拿掉 L，避免殘留英文參數
        var qIndexCh = hashPath.indexOf('?');
        if (qIndexCh === -1) return hashPath;
        var pathPartCh = hashPath.substring(0, qIndexCh);
        var nextQueryCh = setQueryValue(hashPath.substring(qIndexCh + 1), 'L', null);
        return nextQueryCh ? pathPartCh + '?' + nextQueryCh : pathPartCh;
    }

    var qIndex = hashPath.indexOf('?');
    var pathPart = qIndex === -1 ? hashPath : hashPath.substring(0, qIndex);
    var queryPart = qIndex === -1 ? '' : hashPath.substring(qIndex + 1);
    var nextQuery = setQueryValue(queryPart, 'L', 'EN');
    return pathPart + '?' + nextQuery;
}

// 依語系補上場地租借 L 參數（選單僅有單一 linkUrl，無英文專用欄位）
export function resolveMenuLinkUrl(linkUrl) {
    if (!linkUrl || !linkUrl.includes('http')) {
        return linkUrl;
    }

    if (linkUrl.indexOf('rent.pe.ntu.edu.tw') === -1) {
        return linkUrl;
    }

    var locale = sessionStorage.getItem('locale') || 'CH';
    var langParam = localeToLangParam(locale);

    try {
        var url = new URL(linkUrl);
        url.searchParams.set('L', langParam);
        return url.toString();
    } catch (error) {
        if (/[?&]L=/i.test(linkUrl)) {
            return linkUrl.replace(/([?&]L=)[^&]*/i, '$1' + langParam);
        }
        var separator = linkUrl.indexOf('?') !== -1 ? '&' : '?';
        return linkUrl + separator + 'L=' + langParam;
    }
}

export function responseDataGroupByTitle(data, groupBy) {
    var myJSON = {};

    for (var i = 0; i < data.length; i++) {
        var title = data[i][groupBy];
        var row = data[i];

        if (!myJSON[title]) myJSON[title] = [];

        myJSON[title].push(row);
    }
    return myJSON;
}



// WEBPACK FOOTER //
// ./src/assets/library/commonFunction.js